export default "__VITE_ASSET__DGMoAe9K__"